import { resetAZMFilterPathFromSessionStorage } from "@modules/global/filter-path/filter-path-handler.ts"

window.Widgets.StripeCore.resetAllMoreStates()

resetAZMFilterPathFromSessionStorage()
// window.Ladies.Utility.OrderedAdverts.clearUrlTree()
